import { render } from "./AddUrlButton.vue?vue&type=template&id=77313974&scoped=true"
import script from "./AddUrlButton.vue?vue&type=script&lang=js"
export * from "./AddUrlButton.vue?vue&type=script&lang=js"

import "./AddUrlButton.vue?vue&type=style&index=0&id=77313974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77313974"]])

export default __exports__